import { Link } from "react-router-dom";
import { Accessibility, GraduationCap, Heart, HandHeart, Globe2, ArrowRight, Sparkles } from "lucide-react";

export default function InitiativesGrid() {
  return (
    <section data-testid="initiatives" className="section-spacing bg-white">
      <div className="nkf-container">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 items-stretch">
          {/* Women */}
          <div className="federation-card relative overflow-hidden rounded-md border border-slate-200 bg-gradient-to-br from-nkf-red/10 to-white p-6 flex flex-col h-full">
            <Heart className="h-7 w-7 text-nkf-red" />
            <h3 className="font-display text-2xl text-nkf-blue mt-4">Women in Karate</h3>
            <p className="text-sm text-slate-600 mt-2 leading-relaxed flex-1">
              30% reserved participation, dedicated women coaches, referees and leadership tracks. NKF Bharat is committed to gender parity at every level.
            </p>
            <Link to="/women" className="inline-flex items-center gap-1 mt-5 text-nkf-red font-semibold hover:underline text-sm">
              Learn more <ArrowRight className="h-4 w-4" />
            </Link>
          </div>

          {/* Para */}
          <div className="federation-card relative overflow-hidden rounded-md border border-slate-200 bg-gradient-to-br from-nkf-blue/10 to-white p-6 flex flex-col h-full">
            <Accessibility className="h-7 w-7 text-nkf-blue" />
            <h3 className="font-display text-2xl text-nkf-blue mt-4">Para Karate</h3>
            <p className="text-sm text-slate-600 mt-2 leading-relaxed flex-1">
              Special children programmes, para athlete pathways, inclusive coaching curriculum and dedicated competition categories.
            </p>
            <Link to="/para" className="inline-flex items-center gap-1 mt-5 text-nkf-blue font-semibold hover:underline text-sm">
              Learn more <ArrowRight className="h-4 w-4" />
            </Link>
          </div>

          {/* Scholarship */}
          <div className="federation-card relative overflow-hidden rounded-md border border-slate-200 bg-gradient-to-br from-nkf-gold/15 to-white p-6 flex flex-col h-full">
            <GraduationCap className="h-7 w-7 text-nkf-gold" />
            <h3 className="font-display text-2xl text-nkf-blue mt-4">Scholarships</h3>
            <ul className="text-sm text-slate-600 mt-2 space-y-1.5 flex-1">
              <li className="flex items-center gap-2"><Sparkles className="h-3 w-3 text-nkf-gold" /> EWS Support</li>
              <li className="flex items-center gap-2"><Sparkles className="h-3 w-3 text-nkf-gold" /> Medalist Scholarship</li>
              <li className="flex items-center gap-2"><Sparkles className="h-3 w-3 text-nkf-gold" /> Youth Scholarship</li>
              <li className="flex items-center gap-2"><Sparkles className="h-3 w-3 text-nkf-gold" /> Development Scholarship</li>
            </ul>
            <Link to="/scholarships" className="inline-flex items-center gap-1 mt-5 text-nkf-blue font-semibold hover:underline text-sm">
              Apply now <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>

        {/* International strip */}
        <div className="mt-10 p-6 md:p-8 rounded-md bg-nkf-navy text-white flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-start gap-4">
            <Globe2 className="h-9 w-9 text-nkf-gold shrink-0" />
            <div>
              <div className="text-[11px] uppercase tracking-[0.3em] text-nkf-gold">International Relations</div>
              <h3 className="font-display text-2xl mt-1">Global Karate Partnerships</h3>
              <p className="text-white/75 text-sm mt-1 max-w-xl">Active collaboration with ITKF, IAKS, ICSSPE, TAFISA, UKF and ITKF Asia/Oceania for global exposure of Indian athletes.</p>
            </div>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-6 text-[11px] uppercase tracking-widest text-white/70">
            <span className="px-3 py-1 rounded-full border border-white/15">ITKF</span>
            <span className="px-3 py-1 rounded-full border border-white/15">IAKS</span>
            <span className="px-3 py-1 rounded-full border border-white/15">ICSSPE</span>
            <span className="px-3 py-1 rounded-full border border-white/15">TAFISA</span>
            <span className="px-3 py-1 rounded-full border border-white/15">UKF</span>
          </div>
        </div>

        {/* Media + Social wall placeholder */}
        <div className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-5">
          <HandHeartCard />
        </div>
      </div>
    </section>
  );
}

function HandHeartCard() {
  return (
    <div className="lg:col-span-3 p-6 md:p-8 rounded-md border border-slate-200 bg-slate-50 flex flex-col md:flex-row items-center justify-between gap-6">
      <div className="flex items-center gap-4">
        <HandHeart className="h-9 w-9 text-nkf-red shrink-0" />
        <div>
          <div className="font-display text-xl text-nkf-blue">Connect with the Federation</div>
          <div className="text-sm text-slate-600">Become a volunteer, mentor, donor or partner. Strengthen Indian karate.</div>
        </div>
      </div>
      <Link to="/contact" className="bg-nkf-blue text-white px-5 py-2.5 rounded text-sm uppercase tracking-widest font-semibold hover:bg-nkf-navy transition">Contact Federation</Link>
    </div>
  );
}
